var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelchair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.902 23.245a1.28 1.28 0 01-.676 1.663c-.599.254-1.294-.04-1.584-.626l-2.588-5.478-4.81-.528-1.158-.137c-.135-.02-.27-.06-.406-.098a1.847 1.847 0 01-.83-.607 2.794 2.794 0 01-.753-1.917l-.058-5.243c0-1.526 1.236-2.779 2.742-2.779.754 0 1.43.313 1.932.822.502.49.81 1.194.81 1.957l.059 4.89 3.67.862.115.039c.445.098.792.41.947.802l2.588 6.378zM11.685 6.439C10.202 6.439 9 5.221 9 3.719 9 2.218 10.202 1 11.685 1c1.482 0 2.684 1.218 2.684 2.72 0 1.501-1.202 2.719-2.684 2.719z",
    fill: "#0C1014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.789 14A5.46 5.46 0 004 18.76c0 3.02 2.456 5.466 5.485 5.466a5.485 5.485 0 005.155-3.596",
    stroke: "#0C1014",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0C1014",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 14V9.984L3.982 8.888"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/wheelchair.08dac48dc4558a63f3269669f8a20412.svg";
export { ForwardRef as ReactComponent };